"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var ProGalleryItem_1 = require("./ProGalleryItem");
var pluginTypes_1 = require("../pluginTypes");
var WixStatics_1 = require("@wix/social-groups-api/dist/src/services/wixStatics/WixStatics");
var ContentConverter_1 = require("../../content/ContentConverter");
var ProGalleryConverter = /** @class */ (function () {
    function ProGalleryConverter(description) {
        var _a;
        var _this = this;
        this.description = description;
        this.convertRawEntity = function (raw) {
            var pluginConverter = _this.pluginConverters[raw.type] || _this.undefinedTypeConverter;
            return pluginConverter(raw);
        };
        this.undefinedTypeConverter = function (raw) {
            return;
        };
        this.convertImage = function (raw) {
            var _a = raw.data.src, itemId = _a.id, file_name = _a.file_name, height = _a.height, width = _a.width;
            var metaData = {
                description: _this.description || '',
                height: height,
                link: { url: '' },
                title: file_name,
                type: ProGalleryItem_1.ProGalleryTypes.IMAGE,
                width: width,
            };
            return {
                itemId: itemId || uuid_1.v5(file_name),
                mediaUrl: WixStatics_1.WixStatics.imageUrl(file_name),
                metaData: metaData,
            };
        };
        this.convertGiphy = function (raw) {
            var _a = raw.data.gif, originalUrl = _a.originalUrl, width = _a.width, height = _a.height;
            var metaData = {
                description: _this.description || '',
                height: height,
                link: { url: '' },
                title: originalUrl,
                type: ProGalleryItem_1.ProGalleryTypes.IMAGE,
                width: width,
            };
            return {
                itemId: uuid_1.v5(originalUrl, uuid_1.v5.URL),
                mediaUrl: originalUrl,
                metaData: metaData,
            };
        };
        this.convertGallery = function (raw) {
            var items = raw.data.items;
            return items.map(function (item) {
                var type = item.metadata.type;
                if (type === 'video') {
                    return _this.convertGalleryVideo(item);
                }
                return _this.convertGalleryImage(item);
            });
        };
        this.convertVideo = function (raw) {
            var metadata = raw.data.metadata;
            if (metadata && metadata.oembed) {
                return _this.convertExternalVideo(raw);
            }
            var _a = raw.data.src, pathname = _a.pathname, _b = _a.thumbnail, width = _b.width, height = _b.height, poster = _b.pathname;
            var videoUrl = WixStatics_1.WixStatics.videoUrl(pathname);
            var metaData = {
                description: _this.description || '',
                focalPoint: [],
                height: height,
                link: { url: '' },
                poster: WixStatics_1.WixStatics.imageUrl(poster),
                title: undefined,
                type: ProGalleryItem_1.ProGalleryTypes.VIDEO,
                videoUrl: videoUrl,
                width: width,
            };
            var videoItem = {
                itemId: uuid_1.v5(videoUrl, uuid_1.v5.URL),
                mediaUrl: videoUrl,
                metaData: metaData,
            };
            return videoItem;
        };
        this.pluginConverters = (_a = {},
            _a[pluginTypes_1.PluginTypes.Image] = this.convertImage,
            _a[pluginTypes_1.PluginTypes.Video] = this.convertVideo,
            _a[pluginTypes_1.PluginTypes.Gallery] = this.convertGallery,
            _a[pluginTypes_1.PluginTypes.Giphy] = this.convertGiphy,
            _a);
    }
    ProGalleryConverter.prototype.getRawDraftEntities = function (entity) {
        try {
            var _a = entity.body, content = _a.content, contentType = _a.contentType;
            if (contentType === types_1.SocialApiTypes.ContentType.DRAFTJS) {
                var converter = new ContentConverter_1.ContentConverter();
                var draftJs = converter.parseDraftJsFromString(content);
                return Object.values(draftJs.entityMap);
            }
        }
        catch (e) {
            console.log('Failed to parse entity');
        }
        return [];
    };
    ProGalleryConverter.prototype.getProGalleryItems = function (rawEntities) {
        this.proGalleryItems = [];
        try {
            for (var _i = 0, rawEntities_1 = rawEntities; _i < rawEntities_1.length; _i++) {
                var raw = rawEntities_1[_i];
                this.proGalleryItems = this.proGalleryItems.concat(this.convertRawEntity(raw) || []);
            }
        }
        catch (e) {
            console.log('Type Error converting RawDraftEntity');
        }
        return this.proGalleryItems;
    };
    ProGalleryConverter.prototype.convert = function (entity) {
        var entities = this.getRawDraftEntities(entity);
        return this.getProGalleryItems(entities);
    };
    ProGalleryConverter.convertContentEntity = function (entity, description) {
        var converter = new ProGalleryConverter(description);
        return converter.convert(entity);
    };
    ProGalleryConverter.prototype.convertGalleryImage = function (item) {
        var itemId = item.itemId, _a = item.metadata, width = _a.width, height = _a.height, url = item.url;
        var metaData = {
            description: this.description || '',
            focalPoint: [],
            height: height,
            width: width,
            type: ProGalleryItem_1.ProGalleryTypes.IMAGE,
            link: { url: '' },
            title: '',
        };
        return { itemId: itemId, mediaUrl: WixStatics_1.WixStatics.imageUrl(url), metaData: metaData };
    };
    ProGalleryConverter.prototype.convertGalleryVideo = function (item) {
        var itemId = item.itemId, _a = item.metadata, width = _a.width, height = _a.height, poster = _a.poster, url = item.url;
        var metaData = {
            poster: WixStatics_1.WixStatics.imageUrl(poster),
            videoUrl: url,
            description: this.description || '',
            focalPoint: [],
            height: height,
            width: width,
            type: ProGalleryItem_1.ProGalleryTypes.VIDEO,
            link: { url: '' },
            title: '',
        };
        return { itemId: itemId, mediaUrl: WixStatics_1.WixStatics.videoUrl(url), metaData: metaData };
    };
    ProGalleryConverter.prototype.convertExternalVideo = function (raw) {
        var _a = raw.data, _b = _a.metadata.oembed, height = _b.height, width = _b.width, html = _b.html, title = _b.title, src = _a.src;
        var metaData = {
            description: this.description || '',
            height: height,
            width: width,
            link: { url: '' },
            title: title,
            type: ProGalleryItem_1.ProGalleryTypes.TEXT,
        };
        return { itemId: uuid_1.v5(src, uuid_1.v5.URL), html: html, metaData: metaData };
    };
    return ProGalleryConverter;
}());
exports.ProGalleryConverter = ProGalleryConverter;
//# sourceMappingURL=ProGalleryConverter.js.map